import { isPlatformServer } from '@angular/common';
import { inject, Injectable, makeStateKey, PLATFORM_ID, signal, StateKey, WritableSignal } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { HomeFlexModel, HomeModel } from '@models/home-page-flex';
import { HotelRepository } from '@repos/hotel.repository';
import { delay, Observable, of, switchMap, tap } from 'rxjs';

@Injectable()
export class HomeUiService {
 private hotelRepo = inject(HotelRepository);
 transferState = inject(TransferState);
 platformid = inject(PLATFORM_ID);
  isActiveTab : WritableSignal<boolean> = signal(false);
  dataInitialized : WritableSignal<boolean> = signal(false);
  getAllSections(accommodation: string): Observable<HomeModel> {
    let allSectionsKey: StateKey<HomeModel> = makeStateKey('allSections');

    if (isPlatformServer(this.platformid)) {
      return this.hotelRepo.getAllSectionsData(accommodation).pipe(
        tap((res) => {
          this.isActiveTab.set(res?.SuggestedTypes?.IsActive ?? false);
          this.dataInitialized.set(true);
          this.transferState.set(allSectionsKey, res);
        })
      );
    }

    const cached = this.transferState.get(allSectionsKey, null as any);
    if (cached) {
      this.transferState.set(allSectionsKey, null);
      this.isActiveTab.set(false); 
      this.dataInitialized.set(true);
      return of(cached);
    }

    return this.hotelRepo.getAllSectionsData(accommodation).pipe(
      tap((res) => {
        this.isActiveTab.set(res?.SuggestedTypes?.IsActive ?? false);
        this.dataInitialized.set(true);
      })
    );
  }
  
  getSectionById(sectionQuery: string): Observable<HomeModel> {
    return this.hotelRepo.getSectionById(sectionQuery).pipe();
  }
}
